'use strict';

// Selector
const selector = {
  wrapper: {
    images: '.js-pdp__wrapper-images',
    basicInfo: '.js-wrapper-basic-info',
    shippingMethodsInfo: '.js-wrapper-shipping-methods-info',
    sizeVariantsDesktop: '.js-wrapper-size-variants-desktop',
    accordionPromotions: '.js-wrapper-accordion-promotions',
    accordionFeatures: '.js-wrapper-accordion-features',
    accordionMeasures: '.js-wrapper-accordion-measures',
    accordionReviews: '.js-wrapper-accordion-reviews',
    accordionExcludedPromotionsMessage:
      '.js-wrapper-accordion-excluded-promotions-message',
    fixedBottomBar: '.js-wrapper-fixed-bottom-bar',
    foursixty: '.js-wrapper-foursixty',
    recommendations: '.js-wrapper-recommendations',
    recommendationsAddons: '.js-wrapper-recommendations-addons',
    modalEyewear: '.js-wrapper-modal-eyewear'
  }
};

// Variables
const elementSelectorsToUpdate = [
  'images',
  'basicInfo',
  'shippingMethodsInfo',
  'sizeVariantsDesktop',
  'accordionPromotions',
  'accordionFeatures',
  'accordionMeasures',
  'accordionReviews',
  'accordionExcludedPromotionsMessage',
  'fixedBottomBar',
  'foursixty',
  'recommendations',
  'recommendationsAddons',
  'modalEyewear'
];
const customEventAfterUpdateContent = new CustomEvent(
  'afterUpdateContentOfProductDetailPage'
);

// Functions

/**
 * Update the content of the product detail page
 * @param {HTMLElement} htmlDoc - The html document with the new content
 * @returns {void}
 */
const updateContent = (htmlDoc) => {
  elementSelectorsToUpdate.forEach((elementSelector) => {
    const currentElement = document.querySelector(
      selector.wrapper[elementSelector]
    );
    const newElement = htmlDoc.querySelector(selector.wrapper[elementSelector]);
    if (currentElement && newElement) {
      currentElement.innerHTML = newElement.innerHTML;
    }
  });

  document.dispatchEvent(customEventAfterUpdateContent);
};
const updateSchemaContent = (htmlSchema) => {
  document.getElementById('productSchemaLd').innerHTML =
    htmlSchema.getElementById('productSchemaLd').innerHTML;
};

export { updateContent, updateSchemaContent };
